module.exports = __webpack_public_path__ + "static/media/400280_01.f79f1c2d.png";